<bn-loading-overlay></bn-loading-overlay>
<div class="container">
    <div class="row" *ngIf="!(usuarioAvaliadorFge$ | async)">
        <div class="col">
            <h4 class="titulo-pagina">Questionário para Avaliação de Eficiência Energética - FGEnergia </h4>
        </div>
        <div class="col-auto">
            <!--<button type="button" class="btn"
            [ngClass]="formGroup.pristine ? 'btn-primary' : 'btn-danger' "
            (click)="cancelar()"> {{ modoEdicao ? "Cancelar" : "Voltar"}}
            </button>

            <button type="button" class="btn btn-primary"
            [disabled]="formGroup.pristine || !formGroup.valid"
            (click)="salvar()">Salvar
            </button>
        -->
            <button class="btn btn-success only-screen" (click)="saveRascunho()" *ngIf="podeSalvarRascunho()">Salvar Rascunho</button>
            <button class="btn btn-success only-screen" (click)="clonar()" *ngIf="podeClonar() && !(usuarioAvaliadorFge$ | async)">Clonar Questionário</button>
            <button class="btn btn-outline-default only-screen" (click)="imprimir()" *ngIf="podeImprimir() && !(usuarioAvaliadorFge$ | async)">Imprimir Questionário</button>
            <button class="btn btn-outline-default only-screen" (click)="voltar()" *ngIf="podeVoltar()">Voltar</button>
            <button class="btn btn-outline-default only-screen" (click)="voltarRevisao()" *ngIf="podeVoltarRevisao()">Voltar</button>
            <button class="btn btn-primary only-screen" (click)="continuar()"   *ngIf="podeContinuar()">Continuar</button>
            <button class="btn btn-primary only-screen" (click)="submeter()" *ngIf="podeConfirmar()">Confirmar</button>
        </div>
    </div>

    <bn-stepper #bnStepper="bnStepper"
        [steps]="steps"
        [(currentStep)]="currentStep"
        (onDisabledSelect)="avisarMotivoParaPassoEstarDesabilitado($event)"
        *ngIf="!isQuestionarioComToken()">
    </bn-stepper>

<div [hidden]="!podeMostrarIdentificacao()">
    <form id="form" name="form" class="form" [formGroup]="formGroup">

        <div class="row mt-5">
            <div class="col">
                <h5>Identificação da Empresa Tomadora de Crédito
                    <span *ngIf="model?.ideRascunho">
                        &nbsp;({{model.ideRascunho}})
                    </span>
                </h5>
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-md-6 col-sm-5">
                <label class="form-label" for="cnpj">CNPJ</label>
                <input
                    bnMask="CNPJ"
                    ngbTooltip="CNPJ do tomador de crédito"
                    class="form-control"
                    id="cnpj"
                    type="text"
                    formControlName="cnpj"
                />
            </div>
            <div class="bn-form-group col-md-6">
                <label class="form-label label-pergunta">
                    A empresa tomadora de crédito será diferente da empresa consumidora beneficiada pelas ações de eficiência energética?
                </label>

                <div>
                    <label class="form-label">
                        <input type="radio" formControlName="isEmpresaTomadoraDiferente" [value]="true" id="is_empresaTomadoraDiferente_true"/>
                        Sim
                    </label>
                    <label class="form-label padding-left-20">
                        <input type="radio" formControlName="isEmpresaTomadoraDiferente" [value]="false" id="is_empresaTomadoraDiferente_false"/>
                        Não
                    </label>
                </div>
                <div *ngIf="isEmpresaTomadoraDiferenteFieldsInvalid()" class="invalid-radio">
                    informe este campo
                </div>
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-lg-6 col-md-6 col-sm-12">
                <label class="form-label">Nome do representante</label>
                <input
                    ngbTooltip=""
                    class="form-control"
                    type="text"
                    formControlName="nomeRepresentante"
                />
            </div>
            <div class="bn-form-group col-lg-6 col-md-6 col-sm-5">
                <label class="form-label">CPF do representante</label>
                <input
                    ngbTooltip=""
                    bnMask="CPF"
                    class="form-control"
                    type="text"
                    formControlName="cpfRepresentante"
                />
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">E-mail do representante </label>
                <input
                    ngbTooltip=""
                    class="form-control"
                    type="text"
                    formControlName="mailRepresentante"
                />
            </div>
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">Telefone do representante</label>
                <input
                    ngbTooltip=""
                    bnMask="CELULAR"
                    class="form-control"
                    type="text"
                    formControlName="telefoneRepresentante"
                />
            </div>
        </div>
        <div class="row">
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">Relação do representante com a empresa</label>
                <input
                    ngbTooltip=""
                    class="form-control"
                    type="text"
                    formControlName="relacaoRepresentante"
                />
            </div>
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">Valor estimado do projeto de eficiência energética</label>
                <input
                        ngbTooltip=""
                        class="form-control"
                        type="text"
                        formControlName="valorEstimadoProjeto"
                        bnMask="MOEDA"
                    />
            </div>
        </div>

        <div class="row" *ngIf="isEmpresaTomadoraDiferente()">
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">CNPJ Consumidor beneficiado</label>
                <input
                    ngbTooltip=""
                    class="form-control"
                    type="text"
                    bnMask="cnpj"
                    formControlName="cnpjBeneficiario"
                />
            </div>
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">Razão social do Consumidor beneficiado</label>
                <input
                        ngbTooltip=""
                        class="form-control"
                        type="text"
                        formControlName="razaoSocialBeneficiario"
                    />
            </div>
        </div>

        <div class="row" *ngIf="isEmpresaTomadoraDiferente()">
            <div class="bn-form-group col-lg-3 col-md-3 col-sm-3">
                <label class="form-label">CEP local implantação</label>
                <input
                    ngbTooltip=""
                    class="form-control"
                    type="text"
                    formControlName="cepBeneficiario"
                    bnMask="CEP"
                />
            </div>
            <div class="bn-form-group col-lg-3 col-md-3 col-sm-3">
                <label class="form-label">Número logradouro local implantação</label>
                <input
                        ngbTooltip=""
                        class="form-control"
                        type="text"
                        formControlName="logradouroBeneficiario"
                    />
            </div>
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">Complemento endereço local implantação</label>
                <input
                        ngbTooltip=""
                        class="form-control"
                        type="text"
                        formControlName="complementoBeneficiario"
                    />
            </div>
        </div>

        <div class="row" *ngIf="isEmpresaTomadoraDiferente()">
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">Nome contato do representante do Consumidor beneficiado</label>
                <input
                    ngbTooltip=""
                    class="form-control"
                    type="text"
                    formControlName="responsavelBeneficiario"
                />
            </div>
            <div class="bn-form-group col-lg-6 col-md-3 col-sm-5">
                <label class="form-label">E-mail representante do Consumidor beneficiado</label>
                <input
                        pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                        ngbTooltip=""
                        class="form-control"
                        type="text"
                        formControlName="emailresponsavelBeneficiario"
                    />
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-lg-12">
                <label class="form-label">Descrição do Projeto</label>
                <textarea class="form-control" formControlName="descricaoProjeto" rows="5"></textarea>
            </div>
        </div>
    </form>
</div>

<!--div [hidden]="!podeMostrarPerguntasAvaliacao()">
    <app-questionario-avaliacao
        *ngIf="perguntasAvaliacaoCarregadas && respostasCarregadas"
        [listaPerguntas]="perguntasFaseAvaliacao"
        [isEsco]="false"
        [listaResposta]="listaResposta">
    </app-questionario-avaliacao>
</div-->

<div [hidden]="!podeMostrarPerguntasQualificacao()">
    <app-questionario-qualificacao
        *ngIf="perguntasQualificacaoCarregadas && respostasCarregadas"
        [listaPerguntas]="perguntasQualificacao"
        [isEsco]="false"
        [listaResposta]="listaResposta"
        [listaMaquinasEquipamentos]="listaMaquinasEquipamentos">
    </app-questionario-qualificacao>
</div>

<div [hidden]="!podeMostrarPerguntasEconomia()">
    <app-questionario-complementar
        *ngIf="perguntasEconomiaCarregadas && respostasCarregadas"
        [listaPerguntas]="perguntasFaseEconomia"
        [isEsco]="false"
        [listaResposta]="listaResposta"
        [valorProjeto]="getValorProjeto()">
    </app-questionario-complementar>
</div>

<div [hidden]="!podeMostrarRecomendacoesAoCliente()">
    <app-questionario-recomendacoes-ao-cliente>
    </app-questionario-recomendacoes-ao-cliente>
</div>

<div *ngIf="podeMostrarRevisao()">
    <app-questionario-revisao
        [listaPerguntas]="getTodasPerguntasParaRevisao()"
        [respostas]="montaRespostasParaRevisao()"
        [dadosCliente]="montaDadosClienteParaRevisao()"
        [descricaoProjeto]="getDescricaoProjetoParaRevisao()"
        [estado]="getEstado()"
        [textoJustificativa]="getJustificativa()"
        [usuarioAvaliadorFge$]="usuarioAvaliadorFge$"
        [idQuestionario]="model.id">

    </app-questionario-revisao>
</div>

    <div *ngIf="podeMostrarQuestionarioEnviado()">
        <div class="titulo-msg-sucesso">
            <strong>PARABÉNS!</strong><br/>
        </div>

        <div class="texto-msg-sucesso">
            Seu projeto de eficiência energética está habilitado no FGEnergia e sua proposta foi registrada nos sistemas do
            BNDES para futura concessão de garantia (CNPJ: {{model.dadosCliente.cnpjCliente}}).
            <br/>
            O código de validação gerado é:
        </div>

        <div class="box-token">
            {{model.token}}
        </div>

        <div class="texto-msg-sucesso">
            Você receberá no endereço eletrônico informado uma cópia do questionário preenchido e do código de validação gerado. Guarde essas informações e procure um Banco credenciado a oferecer a garantia pelo FGEnergia para dar continuidade ao financiamento do seu projeto de eficiência energética.
            <br/>
            <br/>
            Cabe lembrar que, dentre os demais itens constantes do Regulamento do FGEnergia a serem observados pelo tomador do crédito, para fins de formalização de Operações com Outorga de Garantia nos termos do Regulamento, o tomador de crédito deverá comprovar ao Agente Financeiro que atende aos seguintes requisitos:
            <br/>
            I – Situação de regularidade do tomador de crédito com a Receita Federal, Dívida Ativa da União e Previdência Social, por meio de certidões comprobatórias;
            <br/>
            II - Situação de regularidade do tomador de crédito perante o Ministério do Trabalho e Emprego, comprovada com a entrega da Relação Anual de Informações Sociais – RAIS ou por meio de Declaração do tomador de crédito no sentido de que as informações de seus trabalhadores relativas ao ano-base anterior foram inseridas no Sistema de Escrituração Digital das Obrigações Fiscais, Previdenciárias e Trabalhistas (e-Social), em atendimento às Portarias nº 1.127, de 14.10.2019, do Ministério da Economia, e nº 1.419, de 23.12.2019, da Secretaria Especial de Previdência e Trabalho do Ministério da Economia; e
            <br/>
            III - Situação de regularidade do tomador de crédito com as obrigações relativas ao FGTS, comprovada mediante apresentação de Certificado de Regularidade do FGTS expedido pela Caixa Econômica Federal.
        </div>
    </div>

    <div class="only-print margin-top-2-point-5" *ngIf="isQuestionarioComToken()">

        <div class="row">
            Os signatários deste documento são responsáveis e atestam a veracidade das respostas fornecidas.
        </div>

        <div class="row margin-top-2-point-5">
            <div class="col-md-6 text-center">
                ________________________________________________________________ <br/>
                        Representante da Empresa Tomadora de Crédito
            </div>
            <div class="col-md-6 text-center">
                ________________________________________________________________ <br/>
                                    Responsável Técnico
            </div>

        </div>
    </div>
</div>
